import { valueToEnum } from 'common/EnumUtils';
import { QueryParams } from 'common/urls/QueryParams';
import { isEmpty } from 'lodash';
import React, { useCallback, useState } from 'react';
import { RouteChildrenProps } from 'react-router';
import { useActiveMealPlanQuery, useActiveSubscriptionsQuery } from 'src/gqlReactTypings.generated.d';
import { Loading } from 'src/shared/design-system/Loading';
import { StringParam, useQueryParam } from 'use-query-params';
import { ConsumerAccount } from '../ConsumerAccount';
import { MealPlansTab } from './MealPlansTab';
import { PreviousOrdersTab } from './PreviousOrdersTab';
import { RecurringSubscriptionsTab } from './RecurringSubscriptionsTab';
import { OrdersListTabs, OrdersListTitle } from './styles';
import { UpcomingOrdersTab } from './UpcomingOrdersTab';
import { TabNames } from './utilities';

export const ConsumerOrdersList: React.FC<RouteChildrenProps> = ({ match }) => {
  const [tab] = useQueryParam(QueryParams.TAB, StringParam);
  const [activeTab, setActiveTab] = useState(tab === 'subscriptions' ? TabNames.SUBSCRIPTIONS : TabNames.PREVIOUS);
  const onTabClick = useCallback((tab: string) => setActiveTab(valueToEnum(TabNames, tab)), [setActiveTab]);

  const mealPlanQueryResult = useActiveMealPlanQuery({
    fetchPolicy: 'cache-and-network',
  });

  const subscriptionQueryResult = useActiveSubscriptionsQuery({
    fetchPolicy: 'cache-and-network',
  });
  const { data: subscriptionData, loading: subscriptionDataLoading } = subscriptionQueryResult;
  const { data: mealPlanData, loading: mealPlanDataLoading } = mealPlanQueryResult;
  const mealPlan = mealPlanData?.getActiveMealPlanForUser;

  if (subscriptionDataLoading || !subscriptionData || mealPlanDataLoading) {
    return <Loading />;
  }

  const { edges } = subscriptionData.activeSubscriptions;
  const hasActiveMealPlan = !!mealPlan?.id;

  const tabs = [
    TabNames.PREVIOUS,
    TabNames.UPCOMING,
    ...(hasActiveMealPlan ? [TabNames.MEAL_PLANS] : []),
    ...(!isEmpty(edges) ? [TabNames.SUBSCRIPTIONS] : []),
  ];

  return (
    <ConsumerAccount match={match}>
      <OrdersListTitle>My orders</OrdersListTitle>
      <OrdersListTabs activeTab={activeTab} onChange={onTabClick} tabs={tabs} />

      {activeTab === TabNames.PREVIOUS && <PreviousOrdersTab />}
      {activeTab === TabNames.UPCOMING && <UpcomingOrdersTab />}
      {activeTab === TabNames.SUBSCRIPTIONS && (
        <RecurringSubscriptionsTab subscriptionsQueryResult={subscriptionQueryResult} />
      )}
      {activeTab === TabNames.MEAL_PLANS && <MealPlansTab mealPlan={mealPlan} />}
    </ConsumerAccount>
  );
};
